import styled from 'styled-components';

export const ImportStyled = styled.div`
  text-align: center;
`;

export const ImportHeaderStyled = styled.div`
  margin-top: 2em;
  margin-bottom: 5em;
`;

export const ImportMessageStyled = styled.aside`
  color: var(--ds-text, var(--ds-fb-text));
  margin-top: 5em;
`;
